const RISK_SCORE_COLORS = [
  '#22c55e', // green: very low risk
  '#84cc16', // lime: low risk
  '#eab308', // yellow: moderate risk
  '#f97316', // orange: high risk
  '#ef4444', // red: very high risk
];

const clampRiskScore = (score) => {
  const value = Number(score);
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.min(100, Math.max(0, value));
};

export const getRiskScoreColor = (score) => {
  const clamped = clampRiskScore(score);
  const colorIndex = Math.min(
    RISK_SCORE_COLORS.length - 1,
    Math.floor(clamped / (100 / RISK_SCORE_COLORS.length))
  );
  return RISK_SCORE_COLORS[colorIndex];
};

export const getRiskScoreChartData = (riskScoreHistory = []) => (
  riskScoreHistory.map(point => ({
    time: point.time,
    value: point.score,
    color: getRiskScoreColor(point.score),
  }))
);

export { RISK_SCORE_COLORS };
